"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettingsChangedEvent = void 0;
class SettingsChangedEvent /*extends java.lang.Throwable*/ {
    static EventType_CacheSizeChanged = "CACHE_CHANGED";
    static EventType_CacheToggled = "CACHE_TOGGLED";
    static EventType_FontChanged = "FONT_CHANGED";
    _EventType;
    constructor(eventType) {
        if (eventType != null && eventType !== "") {
            this._EventType = eventType;
        }
    }
    getEventType() {
        return this._EventType;
    }
}
exports.SettingsChangedEvent = SettingsChangedEvent;
//# sourceMappingURL=SettingsChangedEvent.js.map